import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import {
  getLegalDocumentURL,
  getOwnerEmailTriggerIdOnlyURL,
  getOwnerEmailTriggerURL,
  getSupportingDocumentURL,
  getPpsrNoGapMoreThanTwentyDaysUrl
} from "../utils/constants/apiEndPoints";

const initialState = {
  loading: false,
  legalDocumentLoading: false,
  supportingDocumentLoading: false,
  ppsrNoGapLoading: false,
  ppsrNoGapData: null
};

const ownerTabSlice = createSlice({
  name: "ownerTab",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchLegalDocumentDataThunk
      .addCase(fetchLegalDocumentDataThunk.pending, (state) => {
        state.legalDocumentLoading = true;
      })
      .addCase(fetchLegalDocumentDataThunk.fulfilled, (state) => {
        state.legalDocumentLoading = false;
      })
      .addCase(fetchLegalDocumentDataThunk.rejected, (state) => {
        state.legalDocumentLoading = false;
      })

      // fetchSupportingDocumentData
      .addCase(fetchSupportingDocumentData.pending, (state) => {
        state.supportingDocumentLoading = true;
      })
      .addCase(fetchSupportingDocumentData.fulfilled, (state) => {
        state.supportingDocumentLoading = false;
      })
      .addCase(fetchSupportingDocumentData.rejected, (state) => {
        state.supportingDocumentLoading = false;
      })
      // getPpsrNoGapMoreThanTwentyDaysThunk
      .addCase(getPpsrNoGapMoreThanTwentyDaysThunk.pending, (state) => {
        state.ppsrNoGapLoading = true;
      })
      .addCase(
        getPpsrNoGapMoreThanTwentyDaysThunk.fulfilled,
        (state, action) => {
          state.ppsrNoGapLoading = false;
          state.ppsrNoGapData = action.payload.data;
        }
      )
      .addCase(getPpsrNoGapMoreThanTwentyDaysThunk.rejected, (state) => {
        state.ppsrNoGapLoading = false;
      });
  }
});

export const getAgreementEmailThunk = createAsyncThunk(
  "ownerTab/getAgreementEmailThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getOwnerEmailTriggerURL(payload.id),
        {},
        {
          params: payload.params
        }
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAgreementEmailIdOnlyThunk = createAsyncThunk(
  "ownerTab/getAgreementEmailIdOnlyThunk",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getOwnerEmailTriggerIdOnlyURL(payload.id)
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchLegalDocumentDataThunk = createAsyncThunk(
  "ownerTab/legalDocument",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getLegalDocumentURL(payload));
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const fetchSupportingDocumentData = createAsyncThunk(
  "ownerTab/SupportingDocument",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getSupportingDocumentURL(payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const getPpsrNoGapMoreThanTwentyDaysThunk = createAsyncThunk(
  "ownerTab/getPpsrNoGapMoreThanTwentyDays",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.post(
        getPpsrNoGapMoreThanTwentyDaysUrl,
        {
          userType: payload.userType,
          userAccountId: payload.userAccountId
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const { setEmailLoading } = ownerTabSlice.actions;
export default ownerTabSlice.reducer;
